var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"m-4 fixed-bottom put-on-top",attrs:{"variant":"danger","dismissible":"","fade":""},model:{value:(_vm.isError),callback:function ($$v) {_vm.isError=$$v},expression:"isError"}},[_vm._v(" "+_vm._s(_vm.$store.state.error.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }